// Pop-up: correct a pending tip (plate / customer / tank size) before approval.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { fmtDate, fmtTime } from './helpers.js';

export default function CorrectionModal({ busy, editFields, editRow, refLists, refresh, saveCorrection, setEditFields, setEditRow, tab }) {
  return (
    <>
      {editRow && (
        <div className="modal-backdrop" onClick={() => { setEditRow(null); setEditFields(null); }}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 420 }}>
            <h3>Correct row — {editRow.licensePlate}</h3>
            <div className="small" style={{ marginBottom: '0.75rem', color: '#666' }}>
              {fmtDate(editRow.date)} {fmtTime(editRow.arrivalTime)}
            </div>
            <label className="small" style={{ display: 'block', marginBottom: '0.5rem' }}>Plate&nbsp;
              <input list="ref-plates" value={editFields.licensePlate}
                     onChange={e => setEditFields({ ...editFields, licensePlate: e.target.value.toUpperCase() })}
                     style={{ width: '100%' }} />
              <datalist id="ref-plates">
                {refLists.plates.map(p => <option key={p.plate} value={p.plate}>{p.customer ? '— ' + p.customer + (p.tankSize ? ' (' + p.tankSize + ' m³)' : '') : ''}</option>)}
              </datalist>
              <span className="small" style={{ color: '#888' }}>type to search; pick from registry or enter a new one</span>
            </label>
            <label className="small" style={{ display: 'block', marginBottom: '0.5rem' }}>Customer&nbsp;
              <select value={editFields.customer}
                      onChange={e => setEditFields({ ...editFields, customer: e.target.value })}
                      style={{ width: '100%' }}>
                <option value="">— select customer —</option>
                {refLists.customers.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
              <span className="small" style={{ color: '#888' }}>new customer? add them in the Reference tab first</span>
            </label>
            <label className="small" style={{ display: 'block', marginBottom: '0.5rem' }}>Tank size (m³)&nbsp;
              <select value={editFields.tankSize}
                      onChange={e => setEditFields({ ...editFields, tankSize: e.target.value })}
                      style={{ width: '120px' }}>
                <option value="">—</option>
                {refLists.tankSizes.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </label>
            {editRow._originalFields && (
              <div className="small" style={{ marginTop: '0.5rem', color: '#666', borderTop: '1px dashed #ddd', paddingTop: '0.5rem' }}>
                Operator originally entered:&nbsp;
                <code>{editRow._originalFields.licensePlate || '—'}</code> ·
                <code style={{ marginLeft: 4 }}>{editRow._originalFields.customer || '—'}</code> ·
                tank&nbsp;<code>{editRow._originalFields.tankSize != null ? editRow._originalFields.tankSize : '—'}</code>
              </div>
            )}
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <button className="refresh-btn" disabled={busy} onClick={saveCorrection} style={{ background: '#16a34a' }}>Save correction</button>
              <button className="refresh-btn" onClick={() => { setEditRow(null); setEditFields(null); }} style={{ background: '#888' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
